import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStoredUser } from '../../utils/format';

const UserProtectedRoute = () => {
    // A valid (not expired) login is required to see the page
    if (getStoredUser()) {
        return <Outlet />;
    } else {
        // If no token, redirect to the login page
        return <Navigate to="/login" replace />;
    }
};

export default UserProtectedRoute;